webpackJsonp([4],{

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_full_js__ = __webpack_require__(257);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a589858_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_vue__ = __webpack_require__(309);
function injectStyle (ssrContext) {
  __webpack_require__(297)
}
var normalizeComponent = __webpack_require__(143)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_full_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a589858_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_backtotop__ = __webpack_require__(304);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    headerView: __WEBPACK_IMPORTED_MODULE_0__components_header__["a" /* default */],
    BackToTop: __WEBPACK_IMPORTED_MODULE_1_vue_backtotop__["a" /* default */]
  },
  created: function created() {
    this.checkUser();
  },
  mounted: function mounted() {
    if (this.$route.meta.group_id !== 3) {
      sessionStorage.invoiceActivePage = 1;
      sessionStorage.invoiceActiveMonth = '';
    }
  }
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(148);


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      menus: []
    };
  },

  methods: {
    logout: function logout() {
      this.$store.commit('clearState');
      this.$router.push('/login');
    },
    Menus: function Menus() {
      var _this = this;

      var header = {
        headers: {
          'access-token': this.$store.state.token
        }
      };
      this.$store.state.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].getMenus(header, function (result) {
        if (result.response === true) {
          _this.menus = result.data.menus;
          var obj = _this.menus.find(function (o) {
            return parseInt(o.group_menu_id) === parseInt(_this.$route.meta.group_id);
          });
          if (!obj) {
            if (_this.$route.meta.group_id !== 99) {
              _this.$router.push('/error');
            }
          }
        } else {
          _this.logout();
        }
        _this.$store.state.isLoading = false;
      }, function (error) {
        alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this.$store.state.isLoading = false;
      });
    }
  },
  mounted: function mounted() {
    if (sessionStorage.user) {
      this.$store.state.token = sessionStorage.token;
      this.Menus();
    }
  }
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BackToTop',
  props: {
    text: {
      type: String,
      default: 'Voltar ao topo'
    },
    visibleoffset: {
      type: [String, Number],
      default: 600
    },
    visibleoffsetbottom: {
      type: [String, Number],
      default: 0
    },
    right: {
      type: String,
      default: '30px'
    },
    bottom: {
      type: String,
      default: '40px'
    },
    scrollFn: {
      type: Function,
      default: function _default(eventObject) {}
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },
  mounted: function mounted() {
    window.smoothscroll = function () {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll);
        window.scrollTo(0, Math.floor(currentScroll - currentScroll / 5));
      }
    };
    window.addEventListener('scroll', this.catchScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.catchScroll);
  },

  methods: {
    /**
     * Catch window scroll event 
     * @return {void}
     */
    catchScroll: function catchScroll() {
      var pastTopOffset = window.pageYOffset > parseInt(this.visibleoffset);
      var pastBottomOffset = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - parseInt(this.visibleoffsetbottom);
      this.visible = parseInt(this.visibleoffsetbottom) > 0 ? pastTopOffset && !pastBottomOffset : pastTopOffset;
      this.scrollFn(this);
    },

    /**
     * The function who make the magics
     * @return {void}
     */
    backToTop: function backToTop() {
      window.smoothscroll();
      this.$emit('scrolled');
    }
  }
});

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(298);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(187)("c5027af2", content, true, {});

/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(186)(true);
// imports


// module
exports.push([module.i, ".btn-bottom{background:#000;color:#fff;width:50px;height:50px;position:fixed;bottom:15px;right:15px;border-radius:5px;opacity:.4;filter:alpha(opacity=40);cursor:pointer;font-size:40px;text-align:center;line-height:50px}", "", {"version":3,"sources":["D:/app/gocode/src/gitlab.com/satit13/VillageService/ui/src/components/full.vue"],"names":[],"mappings":"AACA,YACE,gBAAiB,AACjB,WAAY,AACZ,WAAY,AACZ,YAAa,AACb,eAAgB,AAChB,YAAa,AACb,WAAY,AACZ,kBAAmB,AACnB,WAAa,AACb,yBAA0B,AAC1B,eAAgB,AAChB,eAAgB,AAChB,kBAAmB,AACnB,gBAAkB,CACnB","file":"full.vue","sourcesContent":["\n.btn-bottom {\r\n  background: #000;\r\n  color: #fff;\r\n  width: 50px;\r\n  height: 50px;\r\n  position: fixed;\r\n  bottom: 15px;\r\n  right: 15px;\r\n  border-radius: 5px;\r\n  opacity: 0.4;\r\n  filter: alpha(opacity=40);\r\n  cursor: pointer;\r\n  font-size: 40px;\r\n  text-align: center;\r\n  line-height: 50px;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_header_js__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72cb4ad3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__(302);
function injectStyle (ssrContext) {
  __webpack_require__(300)
}
var normalizeComponent = __webpack_require__(143)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72cb4ad3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(301);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(187)("43f9f99d", content, true, {});

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(186)(true);
// imports


// module
exports.push([module.i, ".dropdown-menu{border:0;border-radius:0}.dropdown-item{color:#fff}", "", {"version":3,"sources":["D:/app/gocode/src/gitlab.com/satit13/VillageService/ui/src/components/header.vue"],"names":[],"mappings":"AACA,eACE,SAAY,AACZ,eAAmB,CACpB,AACD,eACE,UAAY,CACb","file":"header.vue","sourcesContent":["\n.dropdown-menu {\r\n  border: 0px;\r\n  border-radius: 0px;\n}\n.dropdown-item {\r\n  color: #fff;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-expand-lg navbar-dark fixed-top",staticStyle:{"background-color":"#4267b2"}},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarTogglerDemo03"}},[_c('ul',{staticClass:"navbar-nav ml-auto"},[_vm._l((_vm.menus),function(menu,m){return _c('li',{key:'menu' + m,staticClass:"nav-item dropdown",class:{ 'active': parseInt(menu.group_menu_id) === parseInt(_vm.$route.meta.group_id) }},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(menu.sub_menu.length < 1),expression:"menu.sub_menu.length < 1"}],staticClass:"nav-link",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$router.push(menu.menu_link)}}},[_c('i',{class:menu.group_menu_icon}),_vm._v(" "+_vm._s(menu.menu_name))]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(menu.sub_menu.length > 0),expression:"menu.sub_menu.length > 0"}],staticClass:"nav-link dropdown-toggle",attrs:{"href":"javascript:void(0)","id":"user","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('i',{class:menu.group_menu_icon}),_vm._v(" "+_vm._s(menu.group_manu_name)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",staticStyle:{"background-color":"#4267b2"},attrs:{"aria-labelledby":"user"}},_vm._l((menu.sub_menu),function(sub,s){return _c('a',{key:'subsMenu' + s + '|' + m,staticClass:"dropdown-item",attrs:{"href":sub.menu_link}},[_vm._v("\n              "+_vm._s(sub.menu_name)+"\n            ")])}),0)])}),_vm._v(" "),_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"href":"javascript:void(0)","id":"user","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('i',{staticClass:"fas fa-user-circle"}),_vm._v(" "+_vm._s(_vm.$store.state.user.username)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",staticStyle:{"background-color":"#4267b2"},attrs:{"aria-labelledby":"user"}},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$router.push('/formuser')}}},[_c('i',{staticClass:"fas fa-user"}),_vm._v(" ข้อมูลผู้ใช้งาน\n            ")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.logout}},[_c('i',{staticClass:"fas fa-power-off"}),_vm._v(" ออกจากระบบ\n            ")])])])],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarTogglerDemo03","aria-controls":"navbarTogglerDemo03","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"navbar-toggler-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-brand",attrs:{"href":"/"}},[_c('img',{attrs:{"src":__webpack_require__(303),"width":"40"}}),_vm._v(" โปรแกรมหมู่บ้าน\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/head-logo-light.95fc4e6.png";

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BackToTop_vue__ = __webpack_require__(305);
 

/**
 * Check why can't use () => {}
 */
__WEBPACK_IMPORTED_MODULE_0__BackToTop_vue__["a" /* default */].install = function (Vue, options) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__BackToTop_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__BackToTop_vue__["a" /* default */])
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BackToTop_vue__["a" /* default */]);


/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BackToTop_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_386676da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BackToTop_vue__ = __webpack_require__(308);
function injectStyle (ssrContext) {
  __webpack_require__(306)
}
var normalizeComponent = __webpack_require__(143)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BackToTop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_386676da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BackToTop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(307);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(187)("25176e7c", content, true, {});

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(186)(true);
// imports


// module
exports.push([module.i, ".back-to-top-fade-enter-active,.back-to-top-fade-leave-active{-webkit-transition:opacity .7s;transition:opacity .7s}.back-to-top-fade-enter,.back-to-top-fade-leave-to{opacity:0}.vue-back-to-top{cursor:pointer;position:fixed;z-index:1000}.vue-back-to-top .default{background-color:#f5c85c;border-radius:3px;color:#fff;height:30px;line-height:30px;text-align:center;width:160px}.vue-back-to-top .default span{color:#fff}.vue-back-to-top--is-footer{bottom:50%!important;position:absolute;-webkit-transform:translateY(50%);transform:translateY(50%)}", "", {"version":3,"sources":["D:/app/gocode/src/gitlab.com/satit13/VillageService/ui/node_modules/vue-backtotop/src/styles.css"],"names":[],"mappings":"AACA,8DAEE,+BAAgC,AAChC,sBAAwB,CACzB,AACD,mDAEE,SAAW,CACZ,AACD,iBACE,eAAe,AACf,eAAgB,AAChB,YAAc,CACf,AACD,0BACE,yBAA0B,AAC1B,kBAAmB,AACnB,WAAe,AACf,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,WAAa,CACd,AACD,+BACE,UAAc,CACf,AACD,4BACE,qBAAuB,AACvB,kBAAmB,AACnB,kCAAmC,AAC3B,yBAA2B,CACpC","file":"styles.css","sourcesContent":["\n.back-to-top-fade-enter-active, \n.back-to-top-fade-leave-active {\n  -webkit-transition: opacity .7s;\n  transition: opacity .7s;\n}\n.back-to-top-fade-enter, \n.back-to-top-fade-leave-to {\n  opacity: 0;\n}\n.vue-back-to-top {\n  cursor:pointer;\n  position: fixed;\n  z-index: 1000;\n}\n.vue-back-to-top .default {\n  background-color: #f5c85c;\n  border-radius: 3px;\n  color: #ffffff;\n  height: 30px;\n  line-height: 30px;\n  text-align: center;\n  width: 160px;\n}\n.vue-back-to-top .default span{\n  color:#ffffff;\n}\n.vue-back-to-top--is-footer {\n  bottom: 50% !important;\n  position: absolute;\n  -webkit-transform: translateY(50%);\n          transform: translateY(50%);\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"back-to-top-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"vue-back-to-top",style:(("bottom:" + (this.bottom) + ";right:" + (this.right) + ";")),on:{"click":_vm.backToTop}},[_vm._t("default",[_c('div',{staticClass:"default"},[_c('span',[_vm._v("\n          "+_vm._s(_vm.text)+"\n        ")])])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('headerView'),_vm._v(" "),_c('main',{staticClass:"container",style:({ 'height': _vm.$store.state.screenHeight - 70 + 'px', 'margin-top': 70 + 'px' })},[_c('div',{staticClass:"hideWhenPrint"},[_c('nav',{staticStyle:{"background":"none!important"},attrs:{"aria-label":"breadcrumb bg-link"}},[_c('ol',{staticClass:"breadcrumb bg-link mb-0",staticStyle:{"background":"none!important"}},[_vm._m(0),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v(_vm._s(_vm.$route.meta.title))])])])]),_vm._v(" "),_c('router-view',{staticClass:"container"})],1),_vm._v(" "),_c('back-to-top',{staticClass:"btn-bottom",attrs:{"visibleoffset":"50"}},[_c('i',{staticClass:"fas fa-chevron-up"})])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"/"}},[_vm._v("Home")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.b042facf4bfc0ac1a138.js